import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const SeedLotId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      type="text"
      name="seedLotId"
      placeholder="Enter seed lot ID"
      label="Seed Lot ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default SeedLotId;
